import { render, staticRenderFns } from "./pmlbindex.vue?vue&type=template&id=27e70c27&"
import script from "./pmlbindex.vue?vue&type=script&lang=js&"
export * from "./pmlbindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports